import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteStoreApi } from "../../services/store/delete.store.api";
import { deleteVoucherApi } from "../../services/vouchers/delete.voucher.api";

export const useDeleteVoucherApi = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: any) => deleteVoucherApi(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["vouchers"],
      });
    },
  });
};
